import { Attribute, Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { EMAIL_PATTERN } from '@cakeiteasy/web-utils';

@Directive({
  standalone: false,
  selector: '[separatedEmails][formControlName],[separatedEmails][formControl],[separatedEmails][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => FewEmailsValidatorDirective), multi: true }
  ]
})
export class FewEmailsValidatorDirective implements Validator {
  constructor(@Attribute('separatedEmails') public separatedEmails: string) {
  }

  validate(control: AbstractControl): { [key: string]: any } {
    let value = control.value || '';
    let separator = this.separatedEmails;

    let hasInvalidEmails = value
      .split(separator)
      .map((email) => email.trim())
      .map((email) => EMAIL_PATTERN.test(email))
      .some((isValid) => !isValid);

    if (value && hasInvalidEmails) {
      return {
        validateEqual: false
      };
    }

    return null;
  }
}
